document.addEventListener('DOMContentLoaded', () => {
  const initCollectionListAccordions = () => {
    const cards = document.querySelectorAll('.tuya-collection-card');
    
    cards.forEach(card => {
      const header = card.querySelector('.tuya-collection-card__header');
      const subcategories = card.querySelector('.tuya-collection-card__subcategories');
      const mask = card.querySelector('.tuya-collection-card__link-mask');
      
      if (header && subcategories) {
        header.addEventListener('click', (e) => {
          if (window.innerWidth <= 1024) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = card.classList.contains('is-open');
            
            cards.forEach(c => {
              if (c !== card) {
                c.classList.remove('is-open');
              }
            });
            
            if (isOpen) {
              card.classList.remove('is-open');
            } else {
              card.classList.add('is-open');
            }
          }
        });
        
        if (mask) {
          mask.addEventListener('click', (e) => {
            if (window.innerWidth <= 1024) {
              e.preventDefault();
              e.stopPropagation();
              header.click();
            }
          });
        }
      }
    });
  };

  initCollectionListAccordions();
  
  document.addEventListener('shopify:section:load', initCollectionListAccordions);
});
